import React from "react";
import { Navigate } from "react-router-dom";
import { useConvexAuth } from "convex/react";

/**
 * PrivateRoute — guards authenticated-only content.
 * Uses Convex Auth's isLoading / isAuthenticated directly.
 */
const PrivateRoute = ({ children }) => {
  const { isLoading, isAuthenticated } = useConvexAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="w-8 h-8 border-[3px] border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/sign-in" replace />;
};

export default PrivateRoute;
